import GameState from "slotworks/model/game-state";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HasLineWins extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        return record.getResultsOfType(LineResult).length > 0 ? Exit.True : Exit.False;
    }
}
